import { useEffect, useState } from 'react';
import './perfilDashboard.css'

const PerfilDashboard = () => {

    const [dataPerfil, setDataPerfil] = useState({
        nombrePerfil: '',
        identificacion: '',
        fechaRegistro: '',
        usuario: '',
        correo: '',
        telefono: '',
        tipoDeNegocio: '',
        tipoDeGestion: ''
    })

    useEffect(() => {
        let usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage)
            setDataPerfil({
                nombrePerfil: `${usuarioLocalStorageObj.nombres} ${usuarioLocalStorageObj.apellidos}`,
                identificacion: usuarioLocalStorageObj.identificacion,
                fechaRegistro: usuarioLocalStorageObj.fechaRegistro,
                usuario: usuarioLocalStorageObj.usuario,
                correo: usuarioLocalStorageObj.correo,
                telefono: usuarioLocalStorageObj.telefono,
                tipoDeNegocio: usuarioLocalStorageObj.labelTipoDeNegocio,
                tipoDeGestion: usuarioLocalStorageObj.labelTipoDeGestion
            })
        }
    }, [])

    return (
        <>
            <div className='div-container-db-mi-perfil'>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                        <div>
                            <h1 className='size-db-mi-perfil-h1'>
                                {dataPerfil.nombrePerfil}
                            </h1>
                            <p className='p-label-form'> No. Identificación: <span>{dataPerfil.identificacion}</span> </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                        <div className="col-12 col-sm-12 col-md-6 col-lg-4" >
                            <div className='div-form'>
                                <p className='p-label-form'> Registro: </p>
                                <p> {dataPerfil.fechaRegistro} </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                        <div className='div-form'>
                            <p className='p-label-form'>Tipo negocio: </p>
                            <p>{dataPerfil.tipoDeNegocio} </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                        <div className='div-form'>
                            <p className='p-label-form'> Tipo Agenda: </p>
                            <p>{dataPerfil.tipoDeGestion} </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                        <div className='div-form'>
                            <p className='p-label-form'>Correo:</p>
                            <p> {dataPerfil.correo} </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                        <div className='div-form'>
                            <p className='p-label-form'>Teléfono: </p>
                            <p> {dataPerfil.telefono} </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PerfilDashboard;